export default __webpack_public_path__ + "static/media/litecoin-ltc-logo.d76270cb.svg";